// Identity — canon Phase 4 (anonymous_id, session_id, quiz_attempt_id, event_id).
// Core logic, port-injected. anonymous_id persists (cookie+localStorage adapter);
// session_id per visit (sessionStorage adapter); quiz_attempt_id created on quiz_open.
import type { IdSource, KeyValueStore } from './types';

const ANON_KEY = 'fg_anon_id';
const SESSION_KEY = 'fg_session_id';
const ATTEMPT_KEY = 'fg_quiz_attempt_id';

export class Identity {
  private attempt: string | undefined;

  constructor(
    private readonly persistent: KeyValueStore,
    private readonly session: KeyValueStore,
    private readonly ids: IdSource,
  ) {}

  anonymousId(): string {
    let id = this.persistent.get(ANON_KEY);
    if (!id) {
      id = this.ids.uuid();
      this.persistent.set(ANON_KEY, id);
    }
    return id;
  }

  sessionId(): string {
    let id = this.session.get(SESSION_KEY);
    if (!id) {
      id = this.ids.uuid();
      this.session.set(SESSION_KEY, id);
    }
    return id;
  }

  startAttempt(): string {
    const existing = this.attemptId();
    if (existing) return existing;
    this.attempt = this.ids.uuid();
    this.session.set(ATTEMPT_KEY, this.attempt);
    return this.attempt;
  }

  attemptId(): string | undefined {
    if (this.attempt) return this.attempt;
    const stored = this.session.get(ATTEMPT_KEY);
    if (stored) this.attempt = stored;
    return this.attempt;
  }

  newEventId(): string {
    return this.ids.uuid();
  }
}
